import React from 'react';

export default function Logo({ size = 40, light = false }) {
  const bgColor = light ? 'rgba(255,255,255,0.2)' : '#1e3a5f';
  const accentColor = '#3b82f6';
  const iconColor = '#ffffff';

  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="12" fill={bgColor} />
      {/* Cube / asset shape */}
      <path d="M24 10L36 17V31L24 38L12 31V17L24 10Z" fill="none" stroke={accentColor} strokeWidth="2" strokeLinejoin="round" />
      <path d="M12 17L24 24L36 17" fill="none" stroke={accentColor} strokeWidth="2" strokeLinejoin="round" />
      <path d="M24 24V38" stroke={accentColor} strokeWidth="2" />
      {/* Check / logic mark */}
      <path d="M19 23L22.5 26.5L29 20" stroke={iconColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
